import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { ELanguageAbr, ELanguageAbrList } from './Constants'

const merchantDashboardUserSchema = {
  firstName: yup
    .string()
    .validCharacters()
    .max(49, () => t('common.errors.tooManyCharacters'))
    .required(),
  lastName: yup
    .string()
    .validCharacters()
    .max(49, () => t('common.errors.tooManyCharacters'))
    .required(),
  email: yup
    .string()
    .email()
    .max(49, () => t('common.errors.tooManyCharacters'))
    .required(),
  merchantId: yup.string(),
  accountEnabled: yup.bool().default(true),
  merchantName: yup.string(),
  language: yup.string().required().oneOf(ELanguageAbrList).default(ELanguageAbr.French),
  isDeveloper: yup.boolean().default(false),
  isAdmin: yup.boolean().default(false),
  hasDetailAccess: yup.boolean().default(false),
  canCreateApplications: yup.boolean().default(false),
  canSendWelcomeMessage: yup.boolean().default(false),
  jobTitle: yup
    .string()
    .max(49, () => t('common.errors.tooManyCharacters'))
    .required(),
  phone: yup.string().validCanadianPhone().notRequired().emptyToNull(),
  fullName: yup.string(),
  lastConnection: yup.date().nullable(),
}

export const MerchantDashboardUserSchema = yup.object(merchantDashboardUserSchema)

export type MerchantDashboardUser = yup.InferSubmit<typeof MerchantDashboardUserSchema>
